export default "__VITE_ASSET__D8ooBENb__"